import React from 'react';
import './BottomNavShell.css';
import './EventsBottomNav.css';
import { DSIcon } from '../design-system/primitives';

// Upcoming and Past used to be nav destinations. They are scopes of one list, so they
// moved into the segmented control on the browse screen and the nav carries what are
// genuinely different places to be: everything, my own, and the admin tools.
const BASE_TABS = [
  { key: 'browse', icon: <DSIcon name="search" />, label: 'Browse' },
  { key: 'mine', icon: <DSIcon name="ticket" />, label: 'My RSVPs' }
];

const ADMIN_TABS = [
  { key: 'admin', icon: <DSIcon name="wrench" />, label: 'Admin' }
];

function EventsBottomNav({ activeTab, onSelectTab, isAdmin }) {
  const tabs = isAdmin ? [...BASE_TABS, ...ADMIN_TABS] : BASE_TABS;

  return (
    <nav className="bn-shell eb-bottomnav">
      {tabs.map((tab) => (
        <button
          key={tab.key}
          type="button"
          className={`bn-shell-item eb-bottomnav-item ${activeTab === tab.key ? 'active' : ''}`}
          onClick={() => onSelectTab(tab.key)}
        >
          <span className="bn-shell-icon eb-bottomnav-icon">{tab.icon}</span>
          <span className="eb-bottomnav-label">{tab.label}</span>
        </button>
      ))}
    </nav>
  );
}

export default EventsBottomNav;
